import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  FiBarChart2,
  FiCalendar,
  FiGrid,
  FiLogOut,
  FiPackage,
  FiUsers,
} from "react-icons/fi";
import Sidebar from "../components/layout/Sidebar";
import { logout } from "../services/authService";

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const adminNavItems = [
    {
      to: "/admin",
      label: "Dashboard",
      icon: FiGrid,
      end: true,
    },
    {
      to: "/admin/services",
      label: "Manage Services",
      icon: FiPackage,
    },
    {
      to: "/admin/bookings",
      label: "Manage Bookings",
      icon: FiCalendar,
    },
    {
      to: "/admin/availability",
      label: "Manage Availability",
      icon: FiCalendar,
    },
    {
      to: "/admin/users",
      label: "Manage Users",
      icon: FiUsers,
    },
    {
      to: "/admin/analytics",
      label: "Analytics",
      icon: FiBarChart2,
    },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const getPageTitle = () => {
    if (location.pathname === "/admin") return "Admin Dashboard";
    if (location.pathname.includes("/admin/services")) return "Manage Services";
    if (location.pathname.includes("/admin/bookings")) return "Manage Bookings";
    if (location.pathname.includes("/admin/availability")) return "Manage Availability";
    if (location.pathname.includes("/admin/users")) return "Manage Users";
    if (location.pathname.includes("/admin/analytics")) return "Analytics";
    return "Admin Panel";
  };

  const getPageSubtitle = () => {
    if (location.pathname === "/admin") {
      return "Monitor bookings, services, availability, users, and business insights from one place.";
    }
    if (location.pathname.includes("/admin/services")) {
      return "Create, update, review, and organize services shown to clients.";
    }
    if (location.pathname.includes("/admin/bookings")) {
      return "Review appointment activity, update booking status, and stay on top of client requests.";
    }
    if (location.pathname.includes("/admin/availability")) {
      return "Set available dates and time ranges so appointments stay aligned with scheduling rules.";
    }
    if (location.pathname.includes("/admin/users")) {
      return "Review registered client accounts and keep user records organized.";
    }
    if (location.pathname.includes("/admin/analytics")) {
      return "Track service trends, booking activity, and overall business performance.";
    }
    return "Administrative tools for managing the business experience.";
  };

  return (
    <div className="app-shell page-gradient">
      <header className="sticky top-0 z-30 border-b border-goldlight bg-white/90 backdrop-blur">
        <div className="container-page flex min-h-[72px] items-center justify-between gap-4 py-4">
          <div>
            <NavLink to="/admin" className="text-2xl font-semibold text-henna">
              Nayra Henna Admin
            </NavLink>
            <p className="mt-1 text-sm text-muted-warm">
              Business management portal
            </p>
          </div>

          <div className="flex items-center gap-3">
            <NavLink
              to="/"
              className="rounded-xl border border-goldlight px-4 py-2 text-sm font-medium text-[#3b2f2f] transition hover:bg-soft-cream hover:text-henna"
            >
              View Client Site
            </NavLink>

            <button
              type="button"
              onClick={handleLogout}
              className="inline-flex items-center gap-2 rounded-xl bg-henna px-4 py-2 text-sm font-medium text-white transition hover:opacity-95"
            >
              <FiLogOut />
              Sign Out
            </button>
          </div>
        </div>
      </header>

      <main className="container-page section-space">
        <div className="admin-grid">
          <Sidebar
            title="Admin Navigation"
            items={adminNavItems}
            footer={
              <div className="rounded-xl bg-soft-cream p-3">
                <p className="text-sm font-semibold text-henna">Admin Reminder</p>
                <p className="mt-1 text-sm text-muted-warm">
                  Keep services, availability, and booking details accurate so the client experience remains smooth and reliable.
                </p>
              </div>
            }
          />

          <section className="min-w-0">
            <div className="content-card-lg mb-6 p-6">
              <h1 className="admin-page-title">{getPageTitle()}</h1>
              <p className="admin-page-subtitle">{getPageSubtitle()}</p>
            </div>

            <div className="min-w-0">
              <Outlet />
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;